import { IFormatter } from '../FormatterTypes';
import { TEDValidateDefault } from '../Validators/TEDValidateDefault';
import { TEDParseDateTime } from '../Parsers/TEDParseDateTime';
import { TEDDisplayDateTime } from '../Displayers/TEDDisplayDateTime';

class TEDFormatDateTime implements IFormatter {
  displayer = TEDDisplayDateTime.getInstance();
  parser = TEDParseDateTime.getInstance();
  validator = TEDValidateDefault.getInstance();
}

export { TEDFormatDateTime };
